import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkSpacing } from 'uitk-react-spacing';
var UitkProgressFlightsStep = function (_a) {
  var _b;
  var label = _a.label,
    index = _a.index,
    labelTextClassName = _a.labelTextClassName,
    labelPartsClassName = _a.labelPartsClassName;
  return React.createElement("span", null, React.createElement("span", {
    className: labelTextClassName
  }, label.text), React.createElement(UitkSpacing, {
    padding: {
      inline: 'one'
    }
  }, React.createElement("span", {
    className: labelPartsClassName
  }, "\u00B7")), React.createElement("span", {
    className: labelPartsClassName
  }, label.origin, React.createElement(UitkSpacing, {
    margin: {
      blockend: 'half'
    }
  }, React.createElement(UitkIcon, {
    id: "".concat(label.icon.id, "-step-").concat(index),
    name: label.icon.id,
    title: label.icon.title,
    size: (_b = label.icon.size) !== null && _b !== void 0 ? _b : UitkIconSize.SMALL
  })), label.destination));
};
UitkProgressFlightsStep.displayName = 'UitkProgressFlightsStep';
export { UitkProgressFlightsStep };